module.exports = __webpack_public_path__ + "assets/images/Vixio_Logo_White.svg";